/**
 * Filters + bulk actions for the shared ops notification inbox.
 */

import React from "react";
import {
  Box,
  Button,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import { Clear, DoneAll, Search } from "@mui/icons-material";

const NotificationFilters = ({
  filters,
  onChange,
  onClear,
  onMarkAllRead,
  unreadCount = 0,
  disableMarkAll = false,
  compact = false,
}) => {
  const update = (patch) => onChange({ ...filters, ...patch });

  return (
    <Stack
      spacing={1.25}
      sx={{ p: compact ? 1.25 : 2, bgcolor: "background.paper" }}
    >
      <Stack direction={{ xs: "column", md: "row" }} spacing={1.25}>
        <TextField
          size="small"
          placeholder="Search notifications..."
          value={filters.search || ""}
          onChange={(e) => update({ search: e.target.value })}
          fullWidth={compact}
          sx={{ flex: 1, minWidth: compact ? "auto" : 200 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search fontSize="small" />
              </InputAdornment>
            ),
          }}
        />

        <Stack direction="row" spacing={1.25}>
          <FormControl size="small" sx={{ flex: compact ? 1 : "0 0 auto", minWidth: compact ? 0 : 140 }}>
            <InputLabel>Priority</InputLabel>
            <Select
              label="Priority"
              value={filters.priority || ""}
              onChange={(e) => update({ priority: e.target.value })}
            >
              <MenuItem value="">All priorities</MenuItem>
              <MenuItem value="urgent">Urgent</MenuItem>
              <MenuItem value="high">High</MenuItem>
              <MenuItem value="medium">Medium</MenuItem>
              <MenuItem value="low">Low</MenuItem>
            </Select>
          </FormControl>

          <FormControl size="small" sx={{ flex: compact ? 1 : "0 0 auto", minWidth: compact ? 0 : 140 }}>
            <InputLabel>Status</InputLabel>
            <Select
              label="Status"
              value={
                filters.isRead === undefined || filters.isRead === ""
                  ? ""
                  : String(filters.isRead)
              }
              onChange={(e) => {
                const v = e.target.value;
                update({
                  isRead: v === "" ? undefined : v === "true",
                });
              }}
            >
              <MenuItem value="">All statuses</MenuItem>
              <MenuItem value="false">Unread</MenuItem>
              <MenuItem value="true">Read</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </Stack>

      <Stack direction="row" spacing={1} sx={{ flexShrink: 0 }}>
        <Button
          startIcon={<Clear />}
          onClick={onClear}
          color="inherit"
          size={compact ? "small" : "medium"}
          sx={compact ? { flex: 1 } : undefined}
        >
          Clear filters
        </Button>
        <Button
          variant="contained"
          color="error"
          startIcon={<DoneAll />}
          onClick={onMarkAllRead}
          disabled={disableMarkAll || unreadCount === 0}
          size={compact ? "small" : "medium"}
          sx={compact ? { flex: 1, whiteSpace: "nowrap" } : undefined}
        >
          Mark all read
        </Button>
      </Stack>
    </Stack>
  );
};

export default NotificationFilters;
